import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const painPoints = [<>
    Sentir ese vacío constante en el estómago y que la cabeza no para de dar
    vueltas después de cada discusión.
  </>, <>
    Dejar que el estrés de afuera (el trabajo, las cuentas, la economía) se
    filtre en la casa y termine explotando entre ustedes por cualquier pavada.
  </>, <>
    Caer en el <strong data-id="element-291">"Cese de Fuego"</strong> constante, donde parecen más
    compañeros de cuarto que una pareja.
  </>, <>
    Acumular resentimiento por cosas del pasado que nunca se hablaron de frente
    ni se resolvieron.
  </>, <>
    Sentir que están al borde de la separación, pero en el fondo{' '}
    <strong data-id="element-292">no quieren tirar todo por la borda</strong>.
  </>];
export function TargetAudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038] relative" data-id="element-293">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-294">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-295">
          <div className="inline-block bg-[#E5A83B]/20 text-[#E5A83B] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-296">
            ¿TE SUENA FAMILIAR?
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-16 font-serif leading-tight" data-id="element-297">
            ¿Sienten que el día a día les está robando el refugio que
            construyeron juntos?
          </h2>

          <div className="bg-[#0D002B] rounded-3xl p-8 md:p-12 border border-[#7C3AED]/30 shadow-[0_10px_40px_-10px_rgba(124,58,237,0.2)] text-left" data-id="element-298">
            <ul className="space-y-8" data-id="element-299">
              {painPoints.map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-300">
                  <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-301">❌</span>
                  <span className="text-[#C4B5FD] text-lg md:text-xl font-sans leading-relaxed" data-id="element-302">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}